<c-theme name="scania" global="true"></c-theme>
<cal-system-notifications>
</cal-system-notifications>
<tds-header class="app-header">
  <tds-header-title><span class="app-title"><img class="app-title-logo" src="assets/scania-wordmark-white.svg" alt="Scania" height="20"><span class="app-title-sep" aria-hidden="true"></span><span class="app-title-name">Cost allocation and Simulation management system</span></span></tds-header-title>
  <tds-header-item slot="end">
    <button type="button" class="theme-switch"
      [attr.aria-label]="themeService.isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'"
      [title]="themeService.isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'"
      (click)="themeService.toggle()">
      @if (themeService.isDarkMode) {
        <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/></svg>
      } @else {
        <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"><path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z"/></svg>
      }
    </button>
  </tds-header-item>
  <tds-header-dropdown slot="end" no-dropdown-icon class="user-menu" tds-aria-label="Account"
    [style.display]="(isLoggedIn$ | async) ? null : 'none'">
    <span slot="label" class="user-avatar" [title]="(profile$ | async)?.name || 'Account'">{{ initials(profile$ | async) }}</span>
    <tds-header-dropdown-list>
      <tds-header-dropdown-list-user
        [attr.header]="(profile$ | async)?.name"
        [attr.subheader]="(profile$ | async)?.idTokenClaims?.email || (profile$ | async)?.username">
      </tds-header-dropdown-list-user>
      <tds-header-dropdown-list-item>
        <button type="button" (click)="logout()">Logout</button>
      </tds-header-dropdown-list-item>
    </tds-header-dropdown-list>
  </tds-header-dropdown>
  <tds-header-brand-symbol slot="end">
    <a aria-label="CALSIUM dashboard" href="./dashboard"></a>
  </tds-header-brand-symbol>
</tds-header>

<c-navigation [cal-menu] [style.visibility]="(isLoggedIn$ | async) ? 'visible' : 'hidden'"
  [menu]="menu$ | async"
  [activeMenu]="activeMenu$ | async"
  [profile]="profile$ | async">
</c-navigation>

@if (idleService.secondsLeft$ | async; as secondsLeft) {
  <div class="idle-backdrop">
    <div class="idle-dialog" role="alertdialog" aria-modal="true" aria-labelledby="idle-title">
      <h2 id="idle-title">Are you still there?</h2>
      <p>For your security you will be signed out in <strong>{{ secondsLeft }}</strong> seconds because of inactivity.</p>
      <div class="idle-actions">
        <button type="button" class="idle-secondary" (click)="idleService.signOutNow()">Sign out</button>
        <button type="button" class="idle-primary" (click)="idleService.staySignedIn()">Stay signed in</button>
      </div>
    </div>
  </div>
}

<c-content>
  <section>
    <router-outlet></router-outlet>
  </section>
</c-content>

<c-footer>
</c-footer>